import React, { Component } from 'react';
import http from "./../services/httpService";
import config from "./../config.json";
import Slider from "react-slick";
class Haberler extends Component {

    state = {  
      news: [],
      header: this.props.header,
      style:{height: this.props.height},
    }


  componentDidMount(){
      this.setValues();
      //this.interval = setInterval(() => this.setValues(), 5000);
  }
  
  componentWillUnmount() {
      //clearInterval(this.interval);
  }

  async setValues(){
      var {data : news} =  await http.get(config.apiEndpoint + 'News');
      this.setState({news})
  }

    render() { 

      const settings = {
        dots: false,
        vertical: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        verticalSwiping: true,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows:false,
      };


        return <div className="card">
          <div className="card-body">
            <h2 className="card-title">{this.state.header}</h2>
            <div className="card-box news" style={this.state.style}>
              <Slider {...settings}>
                  {this.state.news.map(tag => <div key={tag['LiveNewId']}>{tag['Name']}</div>)}
              </Slider>
            </div>
          </div>
        </div>;
    }   
}
 
export default Haberler;